<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="smkitem-main">
    <Menus :menu="menus" @menuClicked="handleMenuClick" />
    <div class="right-container">
      <TableBox title="All SMK Items" :tableData="SMKItemData" :selectedRow.sync="selectedSMKItem" v-if="reloadTable" />
      <PopupEntry
        v-if="popupEntryShow"
        :show.sync="popupEntryShow"
        :title="popUpTitle"
        :viewMode="viewMode"
        @save="saveClick"
      >
        <InputQuery
          placeholder="Customer Code"
          :items="customerData"
          itemKey="custNumberAndName"
          :selectedObject.sync="selectedCustomer"
          :isRequired="true"
          :isDisabled="viewMode || popUpAction === 'E'"
          :errorMessage="customerErrMsg"
          :tableBoxHideColumns="['custNumberAndName']"
          @selected="onSelectCustomer"
        />

        <InputQuery
          placeholder="Item Code"
          :items="SMKItemInputQueryData"
          itemKey="Item Code"
          :selectedObject.sync="selectedSMKItemInputQuery"
          :isRequired="true"
          :isDisabled="viewMode || popUpAction === 'E'"
          :errorMessage="SMKItemErrMsg"
          :allowFreeText="true"
          :search.sync="SMKItemText"
        />

        <InputQuery
          placeholder="Product Code"
          :items="SMKProductData"
          itemKey="fullDescription"
          :selectedObject.sync="selectedSMKProduct"
          :isDisabled="viewMode || popUpAction === 'E' || selectedCustomer === null"
        />

        <RemarksBox title="Item Description" :text.sync="SMKItemDesc" :isDisabled="viewMode" :maxLength="350" />

        <Dropdown
          placeholder="UOM"
          :items="SMKItemUOMData"
          itemKey="fullDescription"
          :selectedObject.sync="selectedSMKItemUOM"
          :isDisabled="viewMode"
        />

        <InputQuery
          placeholder="Tariff Code"
          :items="SMKTCData"
          itemKey="fullTC"
          :selectedObject.sync="selectedTC"
          :isDisabled="viewMode"
        />
      </PopupEntry>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  data: function () {
    return {
      menus: [
        {
          title: 'Create SMK Item',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          key: 'MnuNew',
          visible: true,
          enabled: true,
        },
        {
          title: 'Edit SMK Item',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          key: 'MnuEdit',
          visible: true,
          enabled: true,
        },
        {
          title: 'Delete SMK Item',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          key: 'MnuDelete',
          visible: false,
          enabled: true,
        },
        {
          title: 'View SMK Item',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png',
          key: '',
          visible: true,
          enabled: true,
        },
      ],
      // Table + Dropdown Data
      SMKItemData: [],
      selectedSMKItem: [],
      reloadTable: true,

      // Popup data
      popupEntryShow: false,
      popUpTitle: '',
      viewMode: true,
      popUpAction: '',

      SMKProductData: null,
      selectedSMKProduct: null,

      selectedSMKItemInputQuery: null,
      SMKItemText: '',
      SMKItemErrMsg: '',
      SMKItemInputQueryData: [],

      customerData: null,
      selectedCustomer: null,
      customerErrMsg: '',

      SMKItemDesc: '',

      SMKItemUOMData: null,
      selectedSMKItemUOM: null,

      SMKTCData: null,
      selectedTC: null,
    };
  },
  props: {},
  methods: {
    handleMenuClick: async function (menu) {
      this.resetFields();
      switch (menu.title) {
        case 'View SMK Item': {
          this.viewMode = true;
          this.popUpTitle = 'View SMK Item';
          this.popUpAction = 'V';
          if (this.selectedSMKItem.length == 0 && this.popUpAction !== 'N') {
            this.$showAlert('error', 'No SMK Item Selected', 'Please select a record to view');
            return;
          }
          await this.populatePopUp();
          break;
        }

        case 'Edit SMK Item': {
          this.viewMode = false;
          this.popUpTitle = 'Edit SMK Item';
          this.popUpAction = 'E';
          if (this.selectedSMKItem.length == 0 && this.popUpAction !== 'N') {
            this.$showAlert('error', 'No SMK Item Selected', 'Please select a record to view');
            return;
          }
          await this.populatePopUp();
          break;
        }
        case 'Create SMK Item': {
          this.viewMode = false;
          this.popUpTitle = 'Create SMK Item';
          this.popUpAction = 'N';
          this.popupEntryShow = true;
          break;
        }
        case 'Delete SMK Item': {
          this.popUpAction = 'D';
          if (this.selectedSMKItem.length == 0) {
            this.$showAlert('error', 'No SMK Item Selected', 'Please select a record to view');
            return;
          }
          const deleting = await this.$showAlert(
            'warning',
            'Delete SMK Item',
            `Are you sure you want to delete this SMK Item?`,
            [
              { text: 'Delete', textColor: 'white', color: 'red' },
              { text: 'Cancel', textColor: 'black', color: 'lightgray' },
            ],
          );

          if (deleting == 'Cancel') {
            return;
          }

          const jsonBody = {
            cu_number: this.selectedSMKItem[0]['Customer Code'],
            productcode: this.selectedSMKItem[0]['Product Code'],
            smkitem: this.selectedSMKItem[0]['Item Code'],
            actionflag: 'D',
          };
          await this.$apiCallV2('/SMKItem/SaveSMKItem', jsonBody);

          await this.reloadTableFunc();
        }
      }
    },
    async onSelectCustomer() {
      this.selectedSMKProduct = null;
      this.SMKProductData = [];
      if (this.selectedCustomer !== null) {
        await this.$apiCallV2('/Master/GetListMaster', {
          masterfile: 'SMKPRODUCTDROPDOWN',
          cu_number: this.selectedCustomer['Customer Code'],
        }).then((result) => {
          this.SMKProductData = result;
          this.SMKProductData.fullDescription = `${'Product Code'} - ${'Product Description'}`;
        });
      }
    },
    async populatePopUp() {
      this.popupEntryShow = true;

      this.selectedCustomer = this.customerData.getSelected(this.selectedSMKItem[0]['Customer Code'], 'Customer Code');
      if (this.popUpAction !== 'N') {
        await this.onSelectCustomer();
      }
      this.selectedSMKItemInputQuery = this.SMKItemInputQueryData.getSelected(
        this.selectedSMKItem[0]['Item Code'],
        'Item Code',
      );
      this.selectedSMKProduct = this.SMKProductData.getSelected(
        this.selectedSMKItem[0]['Product Code'],
        'Product Code',
      );
      this.SMKItemDesc = this.selectedSMKItem[0]['Item Name'];
      const tcCode = this.selectedSMKItem[0]['Tariff Code'].split(/[\s.]/).join('');
      // this.selectedTC = this.SMKTCData.getSelected(tcCode, 'Tariff Code');
      this.selectedTC = this.SMKTCData.find((tc) => tcCode === tc['Tariff Code'].split(/[\s.]/).join(''));
      // consolelog
      this.selectedSMKItemUOM = this.SMKItemUOMData.getSelected(this.selectedSMKItem[0]['Unit Code'], 'UnitCode');
    },
    resetFields() {
      this.selectedCustomer = null;
      this.selectedSMKItemInputQuery = null;
      this.SMKItemText = '';
      this.selectedSMKProduct = null;
      this.SMKProductData = [];
      this.SMKItemDesc = '';
      this.selectedTC = null;
      this.selectedSMKItemUOM = null;
    },
    async reloadTableFunc() {
      await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKEXEMPTITEM' }).then((result) => {
        this.SMKItemData = result;
      });
      this.reloadTable = false;
      this.$nextTick(() => {
        this.reloadTable = true;
        this.selectedSMKItem = [];
      });
    },
    async saveClick() {
      if (this.selectedCustomer === null) {
        this.customerErrMsg = 'Fill in customer field';
        return;
      }
      if (this.SMKItemText === '' || this.SMKItemText === null) {
        this.SMKItemErrMsg = 'Fill in SMK Item Code';
        return;
      }
      const jsonBody = {
        smkitem: this.SMKItemText,
        productcode: this.selectedSMKProduct?.['Product Code'] ?? '',
        cu_number: this.selectedCustomer?.['Customer Code'] ?? '',
        smkitemdesc: this.SMKItemDesc,
        tariffcode: this.selectedTC['Tariff Code'] ?? '',
        smkitemuom: this.selectedSMKItemUOM?.['UnitCode'] ?? '',
      };

      jsonBody['actionflag'] = this.popUpAction;
      await this.$apiCallV2('/SMKItem/SaveSMKItem', jsonBody);

      await this.reloadTableFunc();
      this.viewMode = true;
      this.popUpTitle = 'View SMK Item';
      this.popUpAction = 'V';
    },
    async sasControlFunction() {
      this.$fullscreenLoading('Checking Security Access');
      const sasControl = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=MASTER&page=SMK Item`);
      sasControl.forEach((k) => {
        //key in menu same as control value from api
        const selectedMenu = this.menus.find((m) => m['key'] == k['Control']);
        if (selectedMenu) {
          selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
        }
      });
      this.$fullscreenLoading('');
    },
  },
  async mounted() {
    await this.sasControlFunction();
    this.$fullscreenLoading('Getting Data');
    const mountedPromises = [];
    let mountedPromisesFulfilledCount = 0;
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKEXEMPTITEM' }).then((result) => {
        this.SMKItemData = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKEXEMPTITEMDROPDOWN' }).then((result) => {
        this.SMKItemInputQueryData = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SHIPPERCONSIGNEE' }).then((result) => {
        this.customerData = result;
        this.customerData.forEach((customer) => {
          customer.custNumberAndName = `${customer['Customer Code']} - ${customer['Customer Name']}`;
        });
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKUNITOFQTY' }).then((result) => {
        this.SMKItemUOMData = result;
        this.SMKItemUOMData.forEach((UOM) => {
          UOM.fullDescription = `${UOM['UnitCode']} - ${UOM['Description']}`;
        });
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    await Promise.allSettled(mountedPromises);

    this.SMKTCData = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKTARIFFCODE' });
    this.SMKTCData.forEach((TC) => {
      TC.fullTC = `${TC['Tariff Code']} - ${TC['Tariff Description']}`;
    });
    this.$fullscreenLoading();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.smkitem-main {
  padding: 5px 45px;
  font-size: 12px;
  display: flex;
  height: 100%;
  > .right-container {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    width: 100%;
    margin-left: 5px;
    overflow: hidden;
  }
  .popup-entry-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;

    > .popup-top-section {
      display: flex;
      flex-direction: column;
      padding-bottom: 5px;
    }
  }
}
</style>
